module.exports = __webpack_public_path__ + "img/cigama.3965ad9c.png";